// extracted by mini-css-extract-plugin
export default {"deliveryValues":"display-delivery-details_deliveryValues__e9a85","container":"display-delivery-details_container__30ad3"};